/* eslint-disable arrow-body-style */
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import SnackBar from './components/Snackbar/SnackBar';
import LinearProgressLoading from './components/loadingBar/LinearProgressLoading';
// context
import { UIContextProvider } from './context/UIContext';


export default function App() {

  const getBasename = () => {
    return `/${process.env.PUBLIC_URL.split('/').pop()}`;
  };
  return (
    <HelmetProvider>
      <UIContextProvider>
      <BrowserRouter basename={getBasename()}>
        <ThemeProvider>
          <ScrollToTop />
          <StyledChart />
          <SnackBar />
          <LinearProgressLoading />
          <Router />
        </ThemeProvider>
      </BrowserRouter>
      </UIContextProvider>
    </HelmetProvider>
  );
}
